import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

const base_new_cmp = environment.base_new_cmp;

@Injectable({
  providedIn: "root",
})
export class NewCmpService {
  private headers = new HttpHeaders({
    Authorization: "Basic " + btoa("dinesh:dinesh"),
  });

  constructor(private http: HttpClient) {}

  getTipoInstrumentos(): Observable<any[]> {
    return this.http.get<any[]>(`${base_new_cmp}/mer/tipoInstrumentos`, {
      headers: this.headers,
    });
  }

  getTypeInstrumentsByMine(faena: string): Observable<any[]> {
    return this.http.get<any[]>(
      `${base_new_cmp}/mer/${faena}/tiposInstrumentos?descargas=true`,
      { headers: this.headers },
    );
  }

  getInstrumentsByTypeInstrument(
    faena: string,
    tipoInstrumentoId: number,
  ): Observable<any[]> {
    return this.http.get<any[]>(
      `${base_new_cmp}/mer/${faena}/instrumentos?tipo_instrumento_id=${tipoInstrumentoId}`,
      { headers: this.headers },
    );
  }

  getSensorTypesByInstrument(
    faena: string,
    instrumentoId: number,
  ): Observable<any[]> {
    return this.http.get<any[]>(
      `${base_new_cmp}/mer/${faena}/instrumentos/${instrumentoId}/tipoSensores`,
      { headers: this.headers },
    );
  }

  getSensorTypesByTypeInstrument(
    faena: string,
    tipoInstrumentoId: number,
  ): Observable<any[]> {
    return this.http.get<any[]>(
      `${base_new_cmp}/mer/${faena}/tiposInstrumentos/${tipoInstrumentoId}/tipoSensores`,
      { headers: this.headers },
    );
  }

  getSensors(
    faena: string,
    instrumentoId?: number,
    tipoSensorId?: number,
  ): Observable<any[]> {
    let url = `${base_new_cmp}/mer/${faena}/sensores`;

    const params: string[] = [];

    if (instrumentoId) {
      params.push(`instrumento_id=${instrumentoId}`);
    }

    if (tipoSensorId) {
      params.push(`tipo_sensor_id=${tipoSensorId}`);
    }

    if (params.length > 0) {
      url += `?${params.join("&")}`;
    }

    return this.http.get<any[]>(url, {
      headers: this.headers,
    });
  }

  descargarDatos(
    faena: string,
    sensor: string,
    filtros: {
      instrumento_id?: string;
      sensor_id?: string;
      startdate?: string;
      enddate?: string;
    },
  ): Observable<Blob> {
    let params = new HttpParams();

    if (filtros.instrumento_id) {
      params = params.set("instrumento_id", filtros.instrumento_id);
    }

    if (filtros.sensor_id) {
      params = params.set("sensor_id", filtros.sensor_id);
    }

    if (filtros.startdate) {
      params = params.set("startdate", filtros.startdate);
    }

    if (filtros.enddate) {
      params = params.set("enddate", filtros.enddate);
    }

    return this.http.get(`${base_new_cmp}/descargas/${faena}/${sensor}`, {
      headers: this.headers,
      params,
      responseType: "blob",
    });
  }

  // getTipoSensores(): Observable<any[]> {
  //   return this.http.get<any[]>(`${base_new_cmp}/mer/tipoSensores`, {
  //     headers: this.headers,
  //   });
  // }

  // getInstrumentos(faena: string): Observable<any[]> {
  //   return this.http.get<any[]>(`${base_new_cmp}/instrumentos`, {
  //     headers: this.headers,
  //     params: { faena },
  //   });
  // }
}
